import { render, staticRenderFns } from "./BlotterList.vue?vue&type=template&id=8da05bb4&scoped=true"
import script from "./BlotterList.vue?vue&type=script&lang=js"
export * from "./BlotterList.vue?vue&type=script&lang=js"
import style0 from "./BlotterList.vue?vue&type=style&index=0&id=8da05bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da05bb4",
  null
  
)

export default component.exports